<script>
import ProductCard from '../../product/ProductCard';
import { mapActions } from 'vuex';

export default {
  components: {
    ProductCard,
  },

  props: {
    cartItems: {
      type: Array,
      required: true,
    },
  },

  methods: {
    ...mapActions('cartPreview', ['removeProduct']),
  },
};
</script>

<template>
  <ul class="product-card-list">
    <li v-for="item in cartItems" :key="item.id" class="product-card-list__entry" data-cy="cart-summary-item">
      <ProductCard
        :id="item.id"
        :name="item.name"
        :vat-information="item.vatInfo"
        :collection="item.collection"
        :image="item.imageProductKey"
        :reference="item.modelReference"
        :sap-reference="item.sapReference"
        :url="item.url"
        :should-display-add-to-wishlist="true"
        :should-display-remove-from-cart="true"
        :on-remove="removeProduct"
        :horizontal="true"
        :tracking="item.tracking"
      >
        <template #price>
          {{ item.price }}
        </template>
        <template #size>
          <div v-if="item.size" data-cy="cart-item__size">
            <span class="text-muted"> {{ $t('Checkout.size') }}: </span>
            {{ item.size }}
          </div>
        </template>
      </ProductCard>
    </li>
  </ul>
</template>
